import "./FormSection.scss";
import { PropsWithChildren } from "react";

export function FormSectionHeader(props: PropsWithChildren) {
  return (
    <p className="form-section-header text-uppercase fw-semibold">
      {props.children}
    </p>
  );
}

export function FormSectionDivider({ subtle }: { subtle?: boolean }) {
  return (
    <hr
      className={`form-section-divider opacity-100${subtle ? " form-section-divider-subtle" : ""}`}
    />
  );
}
